export default __webpack_public_path__ + "assets/images/homepageacademy-facebook-share-kurs-na-zahtev.png";